// extracted by mini-css-extract-plugin
module.exports = {"postalEntryContainer":"PostalEntry_postalEntryContainer__xJxmb"};